<div fxLayout="row" fxLayoutGap="{{ gapBetweenColorsInPixels }}px">
  <vdw-ellipsis-label class="material-type-name" *ngIf="canShowMaterialTypeName()" [text]="showMaterialTypeName()" matTooltipPosition="below"></vdw-ellipsis-label>
  <div *ngIf="isMaterialSetOfTypeColorSet()" fxLayout="row" fxLayoutGap="8px">
    <div *ngFor="let materialType of getMaterialTypesToShow()">
      <div [matTooltip]="materialType.name" class="color-preview" [style.background-color]="materialType.hexadecimalColorCode" [style.color]="materialType.hexadecimalColorCode"></div>
    </div>
  </div>

  <app-more-items-available *ngIf="moreMaterialTypesAvailable()" [maximumItemsToShow]="maxMaterialTypesToShow" [items]="creelPosition.getUniqueItems()"></app-more-items-available>
</div>
